import { StatePersistenceService } from "@services/state-persistence.service";

import { computed, effect, inject, Service, signal } from "@angular/core";

export interface SessionStateModel {
  ssoToken: string | null;
  refreshToken: string | null;
  expiresInSeconds: number | null;
  expiresAt: string | null;
}

const DEFAULT_STATE: SessionStateModel = {
  ssoToken: null,
  refreshToken: null,
  expiresInSeconds: null,
  expiresAt: null,
};

@Service()
export class SessionStore {
  private readonly persistence = inject(StatePersistenceService);
  private state = signal({
    ...DEFAULT_STATE,
    ...this.persistence.read<Partial<SessionStateModel>>("Session", {}),
  });

  ssoToken = computed(() => this.state().ssoToken);
  refreshToken = computed(() => this.state().refreshToken);
  expiresInSeconds = computed(() => this.state().expiresInSeconds);
  expiresAt = computed(() => this.state().expiresAt);

  constructor() {
    effect(() => this.persistence.write("Session", this.state()));
  }

  setSession(ssoToken: string, refreshToken: string, expiresInSeconds: number) {
    this.state.set({
      ssoToken,
      refreshToken,
      expiresInSeconds,
      expiresAt: new Date(Date.now() + expiresInSeconds * 1000).toISOString(),
    });
  }

  clearSession() {
    this.state.set(DEFAULT_STATE);
  }
}
